import { render, staticRenderFns } from "./RegisterNewMember.vue?vue&type=template&id=95e06a48&scoped=true&"
import script from "./RegisterNewMember.vue?vue&type=script&lang=js&"
export * from "./RegisterNewMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e06a48",
  null
  
)

export default component.exports